/* Mint-Cost-iPad › Đề nghị TT + Tạm ứng. Màu chỉ var(--…). */
.acc { margin-bottom: 14px; padding: 12px 16px; border-radius: 14px; background: var(--card); box-shadow: var(--sh); font-size: 13px; color: var(--tx2); }
.grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 14px; }
.card { padding: 16px; border-radius: 18px; background: var(--card); box-shadow: var(--sh); display: flex; flex-direction: column; gap: 10px; }
.top { display: flex; justify-content: space-between; align-items: baseline; }
.no { font-weight: var(--fw-label); color: var(--link); }
.amt { font-size: 18px; font-weight: var(--fw-label); }
.ncc { display: flex; align-items: center; gap: 8px; color: var(--tx2); }
.ell { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.pay { flex-shrink: 0; padding: 1px 8px; border-radius: 6px; font-size: 13px; font-weight: var(--fw-label); }
.pay_BNK { background: var(--pri-bg); color: var(--link); }
.pay_EMP { background: var(--warn-bg); color: var(--warn); }
.sub { font-size: 13px; color: var(--lb); }
.chips { display: flex; gap: 6px; flex-wrap: wrap; }
.step { padding: 3px 9px; border-radius: 7px; font-size: 13px; font-weight: var(--fw-label); }
.step_done { background: var(--ok-bg); color: var(--ok); }
.step_now { background: var(--pri-bg); color: var(--link); }
.step_todo { background: var(--sub); color: var(--lb); }
.row { display: flex; gap: 8px; }
.end { display: flex; justify-content: flex-end; margin-bottom: 10px; }
.list { border-radius: 18px; background: var(--card); box-shadow: var(--sh); padding: 6px 18px; }
.adv { display: flex; align-items: center; gap: 14px; min-height: 64px; border-bottom: 1px solid var(--line); }
.adv:last-child { border-bottom: 0; }
.grow { flex-grow: 1; min-width: 0; }
.who { font-weight: var(--fw-label); }
.err { color: var(--err); }
.nw { white-space: nowrap; }
.pill { padding: 4px 10px; border-radius: 999px; font-size: 13px; font-weight: var(--fw-label); white-space: nowrap; }
.p_open { background: var(--pri-bg); color: var(--link); }
.p_over { background: var(--err-bg); color: var(--err); }
.p_done { background: var(--ok-bg); color: var(--ok); }
